import { POLL_TIME_LIVE, POLL_TIME_LIVE_BADGE } from '@/lib/query-client';

/**
 * What the live-call count badges show (ADR-315). Pure so the rules are
 * testable without a query client.
 */

/** Largest number a badge spells out; anything above reads `99+`. */
export const LIVE_COUNT_BADGE_MAX = 99;

/**
 * The count to display, or 0 for "show nothing".
 *
 * Nothing while the count is unknown (still loading, or the user may not
 * read calls), and nothing after a failed poll: React Query keeps the last
 * successful `data` through an error, and a number that may no longer be
 * true is worse than no number.
 */
export function liveCountToShow(query: {
  data: { total: number } | undefined;
  isError: boolean;
}): number {
  if (query.isError || !query.data) return 0;
  return Math.max(0, query.data.total);
}

/** `7` → `"7"`, `140` → `"99+"`, so a badge never outgrows its icon. */
export function liveCountLabel(count: number): string {
  return count > LIVE_COUNT_BADGE_MAX ? `${LIVE_COUNT_BADGE_MAX}+` : String(count);
}

/**
 * How often the count is polled from `pathname`: the live cadence on the
 * Calls pages (history and live), where the number sits next to the calls,
 * and the slower badge cadence everywhere else.
 */
export function liveCountPollInterval(pathname: string): number {
  return pathname === '/calls' || pathname.startsWith('/calls/')
    ? POLL_TIME_LIVE
    : POLL_TIME_LIVE_BADGE;
}
